"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const mainData_1 = __importDefault(require("../application/mainData"));
exports.default = (0, vue_1.defineComponent)({
    name: 'ApplicationInfo',
    components: {
        ComplexEditForm: antd_1.ComplexEditForm
    },
    props: {
        id: {
            type: String
        }
    },
    data() {
        return {
            mainData: mainData_1.default,
            detail: undefined,
        };
    },
    watch: {
        id(value) {
            if (value) {
                this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.mainData.$reset();
    },
    methods: {
        loadData() {
            if (this.id) {
                litigation_1.default.litigationApplicationInfo.require({
                    id: this.id
                }).then(res => {
                    const detail = this.mainData.$createDataByDictionary(res.data.data);
                    this.detail = detail;
                    const editForm = this.$refs['edit-form'];
                    editForm.show('log_info', 'change', this.detail);
                });
            }
        }
    }
});
